/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { NenEventToken, NenEventTokenInterface } from "../NenEventToken";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "uri_",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tos",
        type: "address[]",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "bulkMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isTransferable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "mintBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newuri",
        type: "string",
      },
    ],
    name: "setURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "toggleIsTransferable",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type NenEventTokenConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: NenEventTokenConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class NenEventToken__factory extends ContractFactory {
  constructor(...args: NenEventTokenConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "NenEventToken";
  }

  deploy(
    uri_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<NenEventToken> {
    return super.deploy(uri_, overrides || {}) as Promise<NenEventToken>;
  }
  getDeployTransaction(
    uri_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(uri_, overrides || {});
  }
  attach(address: string): NenEventToken {
    return super.attach(address) as NenEventToken;
  }
  connect(signer: Signer): NenEventToken__factory {
    return super.connect(signer) as NenEventToken__factory;
  }
  static readonly contractName: "NenEventToken";
  public readonly contractName: "NenEventToken";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NenEventTokenInterface {
    return new utils.Interface(_abi) as NenEventTokenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NenEventToken {
    return new Contract(address, _abi, signerOrProvider) as NenEventToken;
  }
}
